import {
  Component,
  OnChanges,
  OnInit,
  SimpleChanges,
  inject,
} from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { FlowbiteService } from '@app/src/app/services/flowbite/flowbite.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent implements OnInit, OnChanges {
  private readonly flowbiteService = inject(FlowbiteService);

  public constructor() {}

  public ngOnInit() {
    this.flowbiteService.load((flowbite) => {
      flowbite.initFlowbite();

      console.log('Flowbite loaded', flowbite);
    });
  }

  public ngOnChanges(changes: SimpleChanges) {}
}
